// Persists the URL the user originally tried to open while logged out, so that
// after an external OAuth flow (Google/Okta via Clerk) — which wipes React
// Router state — we can still redirect them back to it.
const STORAGE_KEY = 'voyage:postLoginRedirect'

export const setPostLoginRedirect = (url: string): void => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, url)
  } catch {
    // sessionStorage may be unavailable (e.g. private mode); fall back to default redirect
  }
}

export const getPostLoginRedirect = (): string | null => {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export const clearPostLoginRedirect = (): void => {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // no-op
  }
}
